/* eslint-disable */
import axios from "axios";
import decryptData from "@/store/auth/decryptData";

export default {
  namespaced: true,
  state: () => ({
    productList: [],
    productListLoaded: false
  }),
  mutations: {
    SET_PRODUCTS(state, roles) {
      state.productList = roles;
      state.productListLoaded = true;
    }
  },
  actions: {
    async fetchProductList({ commit, state }) {
      if (!state.productListLoaded) {
        const res = await axios.get(
          "product-categories/list?skip=0&limit=5000"
        );
        const data = decryptData(res.data.payload).data.productCategories;
        const formatted = data.map(item => ({
          value: item.name,
          label: item.name
        }));
        commit("SET_PRODUCTS", [...formatted]);
      }
    }
  },
  getters: {
    productList: state => state.productList,
    productListLoaded: state => state.productListLoaded
  }
};
